module.exports = __webpack_public_path__ + "static/media/feature-cake-2.f1bb87a3.jpg";